import { useLanguage } from '@/hooks/Contexts'
import { Action0 } from '@/utils/Types'
import { FC } from 'react'
import { ImgAltSpan } from '../Image'

export const PayButtonGroup: FC<{ cardClick: Action0; paypalClick: Action0; disabled?: boolean; extraCls?: string }> = ({
  cardClick,
  paypalClick,
  disabled,
  extraCls,
}) => {
  const { payment: payStr } = useLanguage()
  return (
    <>
      <button
        disabled={disabled}
        type='button'
        className={`btn-rd-cyan btn-hover-cyan btn-disabled-grey whitespace-nowrap ${extraCls || ''}`}
        onClick={cardClick}
        data-testid='btn-payCard'
      >
        {payStr.pay_with_card}
      </button>
      <button
        disabled={disabled}
        type='button'
        className={`btn-rd-amber btn-hover-amber btn-disabled-grey flex items-center justify-center whitespace-nowrap ${extraCls || ''}`}
        onClick={paypalClick}
        data-testid='btn-payPaypal'
      >
        {payStr.pay_with}
        <ImgAltSpan src='/assets/payments/PayPal_logo.png' alt='PayPal' className='ml-2 h-auto w-16' />
      </button>
    </>
  )
}

export default PayButtonGroup
